/* src/app/modules/ct-status/components/cts-gantry-timezone-select/cts-gantry-timezone-select.component.scss */
:host {
  display: block;
}
sh-dropdown#time-zone-init-status {
  width: 15rem;
}
.group-text {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=cts-gantry-timezone-select.component.css.map */
